export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_06.7e8ede32.jpg";